"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getActionClauseTypeOptions_1 = require("./getActionClauseTypeOptions");
var getConditionalExceptionClauseTypeOptions_1 = require("./getConditionalExceptionClauseTypeOptions");
var getExistingClauseTypesInSection_1 = require("owa-inbox-rules-option/lib/actions/helpers/getExistingClauseTypesInSection");
function hasUsedAllClauseTypesInSection(sectionType) {
    var numExistingClauseTypes = getExistingClauseTypesInSection_1.default(sectionType).size;
    if (sectionType == 'conditional' || sectionType == 'exception') {
        return getConditionalExceptionClauseTypeOptions_1.default().length == numExistingClauseTypes;
    }
    else if (sectionType == 'action') {
        return getActionClauseTypeOptions_1.default().length == numExistingClauseTypes;
    }
    else {
        throw new Error('Cannot determine max number of clauses for unknown section type');
    }
}
exports.default = hasUsedAllClauseTypesInSection;
//# sourceMappingURL=hasUsedAllClauseTypesInSection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/hasUsedAllClauseTypesInSection.js
// module id = 3174
// module chunks = 2 90